import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AccountService } from './account.service';
import { SCAMP_API } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { CheckList } from 'src/app/models/CheckList.model';
import { TipoCheckList } from 'src/app/models/tipoCheckList.model';

@Injectable()
export class TipoCheckListService {

    constructor(
        private http: HttpClient,
        private account: AccountService
    ) { }

    getTiposCheckListComCheckLists(): Observable<TipoCheckList[]> {
        return this.http.get<TipoCheckList[]>(
            `${SCAMP_API.accountApiV1}/tiposchecklist-com-checklists`,
            {headers : this.account.composeHeaders()}
            );
    }




}
